(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Clavier mobile : le panier se cale sur la zone visible au lieu de faire descendre toute la page.
  if (window.visualViewport && !window.__imCartViewport) {
    window.__imCartViewport = true;
    const viewport = window.visualViewport;
    const sync = () => {
      const panel = document.querySelector('#cart-drawer .im-cart-panel');
      if (!panel) return;
      const keyboardOpen = viewport.height < window.innerHeight - 80;
      panel.style.setProperty('--im-vv-height', keyboardOpen ? `${viewport.height}px` : '100dvh');
      panel.style.setProperty('--im-vv-top', keyboardOpen ? `${viewport.offsetTop}px` : '0px');
    };
    viewport.addEventListener('resize', sync);
    viewport.addEventListener('scroll', sync);
    document.addEventListener('focusin', event => {
      if (event.target instanceof Element && event.target.matches('#cart-drawer .cart-discount__input')) setTimeout(sync, 300);
    });
  }

  if (!customElements.get('im-cart-carousel')) {
    customElements.define('im-cart-carousel', class extends HTMLElement {
      connectedCallback() {
        this.onCarouselClick = (event) => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('[data-im-slide]');
          if (!button || !this.contains(button)) return;
          const track = this.querySelector('.im-cart-suggestions__track');
          if (!track) return;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: Number(button.dataset.imSlide) * (track.clientWidth + 10), behavior: reducedMotion ? 'instant' : 'smooth' });
        };
        this.addEventListener('click', this.onCarouselClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onCarouselClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
